'use client'

import { useEffect, useState } from 'react'

import { usePathname } from 'next/navigation'

import LinearProgress from '@mui/material/LinearProgress'

const ProgressBar = () => {
  const [progress, setProgress] = useState(0)
  const [loading, setLoading] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    const handleStart = () => {
      setLoading(true)
      setProgress(10)
    }

    // Selesaikan loading tanpa timeout
    const handleComplete = () => {
      setProgress(100)
      setLoading(false)
    }

    handleStart()
    handleComplete()
  }, [pathname])

  useEffect(() => {
    if (loading && progress < 100) {
      let animationFrame: number

      const updateProgress = () => {
        setProgress(prev => {
          const increment = Math.random() * 10 + 5

          if (prev + increment >= 100) {
            return 100
          }

          return prev + increment
        })

        if (progress < 100) {
          animationFrame = requestAnimationFrame(updateProgress)
        }
      }

      animationFrame = requestAnimationFrame(updateProgress)

      return () => cancelAnimationFrame(animationFrame)
    }
  }, [loading, progress])

  return (
    <div className={`progress-bar ${loading ? 'loading' : ''}`}>
      {/* <div className='progress' style={{ width: `${progress}%`, transition: 'width 0.2s ease' }} /> */}
      <LinearProgress
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.2)', // warna track (belakang)
          '& .MuiLinearProgress-bar': {
            backgroundColor: 'white' // warna progress bar
          }
        }}
      />
    </div>
  )
}

export default ProgressBar
